export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    color: 'accent',
    description: 'Discover the latest sneaker and shoe finds from top sellers with detailed QC photos and sizing guides.',
    imageQuery: 'Minimalist%20product%20photography%20of%20white%20sneakers%20on%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20simple%20composition%20with%20organic%20shadows%2C%20high%20detail%20texture%20on%20shoe%20material%2C%20fashion%20editorial%20vibe',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    color: 'secondary',
    description: 'Browse curated hoodie and sweater collections with verified quality control reports and sizing charts.',
    imageQuery: 'Soft%20minimalist%20product%20photography%20of%20cream%20colored%20hoodie%20folded%20on%20warm%20beige%20surface%2C%20natural%20window%20light%2C%20clean%20aesthetic%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20background%2C%20high%20fabric%20texture%20detail%2C%20cozy%20atmosphere',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    color: 'accent',
    description: 'Explore quality t-shirt finds across various styles, fabrics, and price points with community reviews.',
    imageQuery: 'Minimalist%20fashion%20photography%20of%20white%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20wooden%20surface%2C%20soft%20morning%20light%2C%20clean%20aesthetic%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20fabric%20texture%20visible%2C%20simple%20composition',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    color: 'secondary',
    description: 'Find premium jackets and outerwear with detailed material breakdowns and seasonal recommendations.',
    imageQuery: 'Elegant%20product%20photography%20of%20beige%20lightweight%20jacket%20draped%20on%20minimalist%20wooden%20hanger%2C%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20aesthetic%2C%20editorial%20fashion%20style%2C%20fabric%20texture%20highlighted%2C%20organic%20shadows',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-checkbox-blank-circle-line',
    color: 'accent',
    description: 'Shop curated pants and shorts collections with fit guides, fabric details, and sizing comparisons.',
    imageQuery: 'Clean%20product%20photography%20of%20beige%20linen%20pants%20folded%20neatly%20on%20light%20neutral%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20aesthetic%2C%20editorial%20fashion%20photography%2C%20warm%20cream%20background%2C%20fabric%20texture%20visible%2C%20simple%20composition',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
    color: 'secondary',
    description: 'Browse caps, beanies, and headwear accessories with style guides and trending picks.',
    imageQuery: 'Minimalist%20product%20photography%20of%20cream%20colored%20baseball%20cap%20on%20warm%20neutral%20surface%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20editorial%20style%2C%20warm%20beige%20background%2C%20simple%20composition%2C%20texture%20and%20stitching%20visible',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    color: 'accent',
    description: 'Discover coordinated outfit sets with complete style breakdowns and matching accessory suggestions.',
    imageQuery: 'Stylish%20product%20photography%20of%20coordinated%20beige%20and%20cream%20clothing%20set%20laid%20flat%20on%20warm%20neutral%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20style%2C%20clean%20minimalist%20aesthetic%2C%20warm%20tones%2C%20high%20detail',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    color: 'secondary',
    description: 'Find comfortable underwear and underpants with fabric quality reviews and sizing advice.',
    imageQuery: 'Clean%20minimalist%20product%20photography%20of%20soft%20cotton%20underwear%20neatly%20folded%20on%20warm%20neutral%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20style%2C%20warm%20cream%20tones%2C%20fabric%20texture%20visible%2C%20simple%20elegant%20composition',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    color: 'accent',
    description: 'Explore sports jerseys and athletic wear with authentic quality checks and team style guides.',
    imageQuery: 'Minimalist%20product%20photography%20of%20athletic%20jersey%20fabric%20draped%20on%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20aesthetic%2C%20editorial%20sports%20style%2C%20warm%20beige%20tones%2C%20fabric%20texture%20highlighted%2C%20professional%20look',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    color: 'secondary',
    description: 'Browse trending accessories including jewelry, watches, sunglasses, and lifestyle items.',
    imageQuery: 'Elegant%20product%20photography%20of%20minimalist%20accessories%20including%20watch%20and%20bracelet%20on%20warm%20neutral%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20clean%20aesthetic%2C%20warm%20cream%20background%2C%20high%20detail%2C%20simple%20composition',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    color: 'accent',
    description: 'Find quality bags and backpacks with detailed material reviews, capacity guides, and style tips.',
    imageQuery: 'Minimalist%20product%20photography%20of%20beige%20canvas%20tote%20bag%20on%20warm%20wooden%20surface%2C%20soft%20natural%20daylight%2C%20clean%20aesthetic%2C%20editorial%20style%2C%20warm%20neutral%20background%2C%20texture%20and%20stitching%20visible%2C%20simple%20composition',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    color: 'secondary',
    description: 'Shop leather and fabric belts with material quality breakdowns and sizing recommendations.',
    imageQuery: 'Clean%20product%20photography%20of%20leather%20belt%20coiled%20on%20warm%20neutral%20surface%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20editorial%20fashion%20style%2C%20warm%20beige%20background%2C%20leather%20texture%20visible%2C%20simple%20elegant%20composition',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    color: 'accent',
    description: 'Discover curated fragrance collections with scent profiles, longevity reviews, and seasonal picks.',
    imageQuery: 'Elegant%20product%20photography%20of%20minimalist%20glass%20perfume%20bottle%20on%20warm%20neutral%20surface%2C%20soft%20natural%20lighting%20with%20gentle%20shadows%2C%20editorial%20beauty%20style%2C%20clean%20aesthetic%2C%20warm%20cream%20background%2C%20simple%20composition%2C%20refined%20atmosphere',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    color: 'secondary',
    description: 'Explore miscellaneous finds including home goods, electronics, gadgets, and unique lifestyle products.',
    imageQuery: 'Minimalist%20lifestyle%20product%20photography%20of%20various%20small%20items%20neatly%20arranged%20on%20warm%20neutral%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20clean%20aesthetic%2C%20warm%20beige%20background%2C%20simple%20composition%2C%20variety%20of%20textures',
  },
];

export const categoryQuickLinks = [
  { name: 'Hipobuy Spreadsheet', url: 'https://kaspreadsheet.com' },
  { name: 'Kakobuy Spreadsheet', url: 'https://kaspreadsheet.com' },
  { name: 'CSSBuy Spreadsheet', url: 'https://kaspreadsheet.com' },
  { name: 'Superbuy Spreadsheet', url: 'https://kaspreadsheet.com' },
  { name: 'Oopbuy Spreadsheet', url: 'https://kaspreadsheet.com' },
];